import { Injectable } from '@angular/core';
// import { Subject }    from 'rxjs/Subject';
// import {Map, MapView,Layer, FeatureLayer, TileLayer, GraphicsLayer,GroupLayer, PopupTemplate, esriConfig } from 'esri-mods';

/**ESRI component(s) for Webpack**/
import Map = require('esri/Map');
import MapView = require('esri/views/MapView');
import esriConfig = require('esri/config');
import TileLayer = require('esri/layers/TileLayer');
import Collection = require('esri/core/Collection');
import Layer = require('esri/layers/Layer');
import FeatureLayer = require('esri/layers/FeatureLayer');
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import GroupLayer = require('esri/layers/GroupLayer');
import PopupTemplate = require('esri/PopupTemplate');
import MapImageLayer = require('esri/layers/MapImageLayer');
import { SettingsService } from '../../shared/settings/settings.service';

//import {AbandonedHomesPopup, PotholesPopup} from './map.popupTemplate';
// import { Http, Response,HTTP_PROVIDERS } from '@angular/http';
// import { Observable }     from 'rxjs/Observable';

@Injectable()
export class MapService {
    // private sliderSource  = new Subject<number>();

    map: Map;
    view: MapView;
    centerX: number;
    centerY: number;
    indyaerial: TileLayer;
    appSettings: Object;
    error: any;
    // sliderValue$ = this.sliderSource.asObservable();

    constructor(private _settingsService:SettingsService) {
        this._settingsService.getAppSettings().subscribe(
            settings => { 
                this.appSettings = settings[0];            
                this.addMapServices();
            },
            err => { this.error = true }
        );
    }

    private addMapServices(){
        esriConfig.request.proxyUrl = "./ESRIProxy/proxy.ashx";
        //  esriConfig.request.useCors = false;
        
        var layers:Collection = new Collection();
        this.appSettings["mapServices"].forEach(mapService => {
            if(mapService.dynamic == false){
                layers.add(new TileLayer({ 
                    id: mapService["id"],
                    url: mapService["url"],
                    opacity: mapService["opacity"]
                }));
            }else{
                layers.add(new MapImageLayer({ 
                    id: mapService["id"],
                    url: mapService["url"],
                    opacity: mapService["opacity"]
                }));
            }
        });
        layers.addMany([
            new GraphicsLayer({
                id: "route"
            }),
            new GraphicsLayer({
                id: "locations"
            })
        ])

         this.map = new Map({
             layers:layers
         });

        this.centerX = 189680;
        this.centerY = 1646766;
    }
}


// WEBPACK FOOTER //
// ./app/information/map/map.service.ts